// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-layout .hash-database.grid {
  padding: 10px 0px 15px 0px;
}

.settings-layout .hash-database.grid .row {
  padding: 5px 0px;
}

.settings-layout .sharing.excludes .add.button {
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Settings/routes/Sharing/style.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".settings-layout .hash-database.grid {\n  padding: 10px 0px 15px 0px;\n}\n\n.settings-layout .hash-database.grid .row {\n  padding: 5px 0px;\n}\n\n.settings-layout .sharing.excludes .add.button {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
